module.exports = __webpack_public_path__ + "static/img/1.a8cddbd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/eng/1.png
// module id = wW7Q
// module chunks = 0